import { Fragment } from "react";
import { Mui } from "@osu/react-ui";
import DescriptionList from "./Description/List";
import CreateLinks from "../../../../Common/components/CreateLinks";
import { ROUTE_KEYS, ROUTES } from "../../../../_configuration/routing/constants";
import AdminDatesEditModal from "./Modal";
import useSessions from "./hooks/useSessions";
import { SectionLoader } from "../../Loading";
import SessionAlert from "./Session/Alert";
import CreateAlertModal from "./CreateAlertModal";

function EditSessions({ baseId, year, yearHeadingId }) {
  const { sessions, isLoading } = useSessions({
    year,
    count: 2,
  })

  return sessions.map((session = {}, idx) => {
    const { year, period, s3Map = {}, isDraft } = session;
    const lastItem = idx === sessions.length - 1;
    const periodHeadingId = baseId + `-${year}-${period}-${idx}`;
    const previewPaths = Object.entries(s3Map).map(([key]) => {
      const routeKey = ROUTES[ROUTE_KEYS.PREVIEW].path
      return {
        title: key.toUpperCase(),
        path: {
          pathname: `${routeKey}/${year}/${period}/${key}`
        }
      }
    })
    const showEditButton = (year && period)
    const EditModal = (props = {}) => <AdminDatesEditModal
      {...props}
      session={session}
      aria-describedby={`${yearHeadingId} ${periodHeadingId}`}
      year={year}
      period={period}
    />
    return (
      <Fragment key={`${year}#${period}#${idx}`}>
        <Mui.Box display="flex" justifyContent="space-between">
          <Mui.Typography
            id={periodHeadingId}
            variant="h4"
          >{`Period ${period}`}</Mui.Typography>
          {(showEditButton && !isDraft) && <EditModal>Edit</EditModal>}
        </Mui.Box>
        <SessionAlert isDraft={isDraft} action={
          <EditModal sx={{
            alignSelf: 'center'
          }} color="inherit" session={session}>
            Create
          </EditModal>}  
        />
        {isDraft && <CreateAlertModal
          Modal={EditModal}
          session={session}
        />}
        {isLoading 
          ? <SectionLoader /> 
          : <DescriptionList
          aria-labelledby={yearHeadingId + " " + periodHeadingId}
          year={year}
          period={period}
          baseId={baseId}
        />}
        <CreateLinks target="_blank" rel="noopener noreferrer" paths={previewPaths} size="small" />
        {!lastItem && <Mui.Divider sx={{ my: 2 }} />}
      </Fragment>
    );
  });
}

export default EditSessions;
